import { Pipe, PipeTransform } from '@angular/core';

import { PhoneNumberPipe } from './phone-number.pipe';

@Pipe({ standalone: true, name: 'incomingCallerDescription' })
export class IncomingCallerDescriptionPipe implements PipeTransform {
  private static phoneNumberPipe = new PhoneNumberPipe();

  transform(selected: { fromLabel?: string; fromNumber: string }): string {
    return IncomingCallerDescriptionPipe.phoneNumberPipe.transform(
      selected.fromLabel && selected.fromLabel?.trim() !== '' ? selected.fromLabel : selected.fromNumber
    );
  }
}
